"use client"

import { useAuth } from "@/contexts/auth-context";
import { useLocation, Navigate } from "react-router-dom";
import { ReactNode } from "react";

export function OnboardingGuard({ children }: { children: ReactNode }) {
  const { hasOrganization, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const isOnboardingPage = location.pathname === '/app/onboarding';

  if (!loading && hasOrganization && isOnboardingPage) {
    // User is onboarded and trying to access onboarding page, redirect to dashboard
    return <Navigate to="/app/dashboard" replace />;
  }

  if (!loading && !hasOrganization && !isOnboardingPage) {
    // User is not onboarded and trying to access a protected page, redirect to onboarding
    return <Navigate to="/app/onboarding" replace />;
  }
  
  // User is in the correct state, render the requested page
  return <>{children}</>;
} 